import { PatientDoc } from '../../../types/Patient/PatientDoc';
import { Chart } from '../../../types/Chart/Chart';
import { updateNavigationObject } from './updateNavigationObject';
import { deepEqual } from '../../../utilities/deepEqual';

export const setDisabledPages = async (patientInfo: PatientDoc, chart: Chart) => {
  const clone = structuredClone(patientInfo) as PatientDoc;
  // HIDE/SHOW PAGES SPECIFIC TO A A SELF GUIDED PATIENT
  if (clone.navType.base === 'self') {
    // ALWAYS SHOW THE HCA INFO PAGE
    clone.navObj.hcaInfo.disabled = false;
    // HIDE/SHOW DOCTOR INFO PAGE IF NO DOCTOR
    clone.navObj['doctorInfo'].disabled = !patientInfo.navInfo.hasDoctor;
    // HIDE/SHOW LAWYER INFO PAGE IF NO LAWYER
    clone.navObj['attorneyInfo'].disabled = !patientInfo.navInfo.hasAttorney;
    // HIDE/SHOW HOSPITAL INFO PAGE IF NO HOSPITAL
    clone.navObj['hospitalInfo'].disabled = !patientInfo.navInfo.hasHospital;
    // HIDE/SHOW FILE UPLOAD PAGE IF NOT UPLOADING DOCUMENTS
    clone.navObj['files'].disabled = !patientInfo.navInfo.uploadingDocuments;
  }

  // HIDE THE PAYMENT PAGE IF THE PATIENT HAS ALREADY PAID
  if (chart?.PAYMENT_INFO?.alreadyPaid === true) {
    clone.navObj.selfPay.disabled = true;
    clone.navObj.thanks.disabled = true;
  }

  // IF PATIENT IS PAYING FOR THEMSELVES, HIDE MEDICARE AND INSURANCE PAGES
  if (patientInfo.navType.base === 'concierge' && chart?.PAYMENT_INFO?.isPayingSelf) {
    clone.navObj.medicareInfo.disabled = true;
    clone.navObj.medicareABN.disabled = true;
    clone.navObj.insuranceInfo.disabled = true;
    clone.navObj.insuranceABN.disabled = true;
    clone.navObj.aob.disabled = true;
  }

  //IF PATIENT IS PAYING WITH INSURANCE, HIDE MEDICARE PAGES AND SELF PAY
  if (chart?.PAYMENT_INFO?.isPayingInsurance) {
    clone.navObj.selfPay.disabled = true;
    clone.navObj.thanks.disabled = true;
    clone.navObj.medicareInfo.disabled = true;
    clone.navObj.medicareABN.disabled = true;
    clone.navObj.insuranceInfo.disabled = false;
    clone.navObj.insuranceABN.disabled = false;
  }

  //IF PATIENT IS PAYING WITH MEDICARE, HIDE INSURANCE PAGES AND SELF PAY
  if (chart?.PAYMENT_INFO?.isPayingMedicare) {
    clone.navObj.selfPay.disabled = true;
    clone.navObj.thanks.disabled = true;
    clone.navObj.medicareInfo.disabled = false;
    clone.navObj.medicareABN.disabled = false;
    clone.navObj.insuranceInfo.disabled = true;
    clone.navObj.insuranceABN.disabled = true;
  }

  //IF PATIENT IS PRE-PAYING WITH MEDICARE, ENABLE SELF PAY & MEDICARE. THEN HIDE INSURANCE PAGES
  if (chart?.PAYMENT_INFO?.isPrePaidMedicare) {
    clone.navObj.selfPay.disabled = false;
    clone.navObj.thanks.disabled = false;
    clone.navObj.medicareInfo.disabled = false;
    clone.navObj.medicareABN.disabled = false;
    clone.navObj.insuranceInfo.disabled = true;
    clone.navObj.insuranceABN.disabled = true;
  }
  //IF PATIENT IS PRE-PAYING WITH INSURANCE ENABLE SELF PAY & INSURANCE. THEN HIDE MEDICARE PAGES
  if (chart?.PAYMENT_INFO?.isPrePaidInsurance) {
    clone.navObj.selfPay.disabled = false;
    clone.navObj.thanks.disabled = false;
    clone.navObj.insuranceInfo.disabled = false;
    clone.navObj.insuranceABN.disabled = false;
    clone.navObj.medicareInfo.disabled = true;
    clone.navObj.medicareABN.disabled = true;
  }

  const updatePayload = {
    source: 'setDisabledPages',
    uid: patientInfo.uid,
    navObj: clone.navObj,
  };

  if (deepEqual(patientInfo.navObj, clone.navObj)) {
    return;
  } else {
    await updateNavigationObject(updatePayload);
  }
};
